import moment from "moment";
import {validation} from "../../helpers";

export default {
    data(){
        return {
            schedulings: null,
            scheduleTimeMinutesOptions: null,
            fromDate: null,
            toDate: null,
            searchDate: Function,
            dateSelected: Function,
            getProduct: Function,
        };
    },
    computed: {
        dateOptions(){
            if(!this.schedulings) {
                return null
            }

            const allDates = [];
            const from = moment(this.fromDate);
            const to = moment(this.toDate);

            for (let i = from; i.isSameOrBefore(to); i.add(1, 'day')) {
                const value = i.format('YYYY-MM-DD');
                const { ok: available } = validation.productScheduleContainsDate(this.schedulings, i);
                const label = (!available ? '(Indisponível) ' : '') + i.format('DD/MM/YYYY');

                allDates.push({ value, available, label });
            }

            return allDates.sort((a,b) => (a.available === b.available) ? 0 : (a.available ? -1 : 1));
        },
        hourOptions() {
            if (this.productWithDateOnly) {
                return [{'value': '', label: 'Produto apenas por data'}];
            }

            if (!this.scheduleTimeMinutesOptions) {
                return null
            }

            const searchDate = this.searchDate();

            const options = this.scheduleTimeMinutesOptions.map(time => {
                let available = true;

                if (searchDate) {
                    const { ok } = validation.productScheduleContainsDateTime(this.schedulings, moment(searchDate.date), time.value);
                    if (!ok) {
                        available = false;
                    } else {
                        available = searchDate.schedulings.some(sch => {
                            if (sch.scheduleAvailabilities) {
                                return sch.scheduleAvailabilities.some(sa => sa.minutes == time.value && sa.available);
                            }

                            // check if there is any tariff occupation available
                            return sch.occupationRates.tariffScheduleQuantities?.some((tsq) =>
                                tsq.occupationSchedule.some((os) => os.minutes == time.value && (os.occupation.availableAmount === null || os.occupation.availableAmount > 0)),
                            );
                        });
                    }
                }

                const label = (available ? '' : '(Indisponível) ') + time.label;

                return { ...time, available, label, value: `${time.value}` };
            });

            return options.sort((a, b) => (a.available === b.available) ? 0 : (a.available ? -1 : 1));
        },
        productWithDateOnly(){
            return this.getProduct().selling_mode === 'with_date_only';
        },
        isScheduleTimeMinutesAvailable(){
            return !this.productWithDateOnly && this.dateSelected();
        },
    }
}
